var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CloudDone481(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.244141,
    y: 0.416016,
    width: 93.6,
    height: 93.6,
    fill: "url(#pattern0_6_14949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_14949",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_14949",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_14949",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC80lEQVR4nO2YS2sTURTHB0Fd6Ubw+THcuNGdmHPS1goq1YUfQOtrK8W6qELuTaxdlRZExIpCRcWWuhCtOSdpjaRJhaKu1GKS0lbtG6XWXplMU0jbJDOTmRDo/OFs8rjz+99z7txzr6Z58uTJkydPm1GBSN0OSXhJML4WjBnBsCQZJyTBmyDD5bZ3vp1atSpIeEYQjktGVSgEw6T+O63aJBmbioFvEE1alc38skUDSpK/Qf9/iH2HJOFDQZAShIuSIC0JH8swHqlIzZcqmyIxIRk7i5YcYXtH/OBW1wzoC9YmvOkQhO2uGdDfNm4bkIwqEPEfdsWAZBirhAHB8MgVA9lFVwkDBCl3DDBMOQEYitSpZKZXPf14o1AGlhyDltGjuyXhdcEQXdlpy4YfHnupZv6Mq+nfY0VM4JxgnBeEg5KhsXnk1Dbr8OQ7KRl+OVUaBnxfFj4XiXSPyXWBiUCkbr95eMbTkuCfs/DGzOdiONOb/dz8ODBkKhOiH/dKglkrgF3DVxV/u68k+03BJzI9KhSptb7AGS6YmH1osTLog+QV9WNhNAsWHe0qCZ+0CS+NjW7QTPl8sDLoyPirPMDw13sF4YfSz1UwUmO/HAlmS5cQ47yVQVsHTqjPk5QH+vbL3XXw8fSz8uA5m4EZMwbmrA7cGq1XnybDecD5b5sXZcNLIwMDjpdQKROxVLcKbrC47RnA82YycNPuA9aaiKWeOAYvGOKm2u07g7V77JTRWhOx792Owt8OH9tXEn61jMjfYOvktWri+IZ7QklQwkXjkgCmjHYConrZ2DroZE2UkQlbM034XnNSejnpG5vei+QaLCdbDLkuoFFzW9m0ujH7jAlXz8Q5BQiu2QDsFAT9Bb8nSFrqNsvRrVj9Lv3SyjQ8wWxowH+gWTVvEQznBENYMk7n+n1BeLGtz7ddq6QCBDWS8a+JRbksGM5q1SjJvlpB+LMI/ExVXi2uLaeVI2d85Q21YLQi0GJp4/HkyZMnT542q/4DGNeWcHNJNPwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CloudDone481);
export default __webpack_public_path__ + "static/media/icons8-cloud-done-48 1.45882e0485929b537aa58ee6e129225a.svg";
export { ForwardRef as ReactComponent };